export const getTypeOfLoan = (notEmployed?: boolean) => (notEmployed ? 'Professional' : 'Employee');
